import { TypeKeys } from '../actions';
import { amplitudeSetUserProperties } from '../global/amplitude';
import { SubscriptionResponse } from '@sworkit/api';
import { signOut } from './auth';
import { validate } from '../global/firestore-user';

export interface CheckingActiveSubscription {
  type: TypeKeys.CHECKING_ACTIVE_SUBSCRIPTION;
}

function checkingActiveSubscription() {
  const action: CheckingActiveSubscription = {
    type: TypeKeys.CHECKING_ACTIVE_SUBSCRIPTION,
  };
  return action;
}
const autoSignOutConditionMet = (accountStatus: SubscriptionResponse) => {
  const { source, subscription_status } = accountStatus;
  return source === 'doctors-of-bc' && subscription_status == 'expired';
};
export const checkActiveSubscription = () => async (dispatch, _getState) => {
  dispatch(checkingActiveSubscription());

  const subscriptionResponse = await validate();

  // dev testing => manual access code
  // const subscriptionResponse: SubscriptionResponse = {
  //   uid: 'facebook:10154323568462281',
  //   product_id: 'SW14DAYSFREE',
  //   is_paying_customer: true,
  //   is_active_subscriber: true,
  //   expires_date: 1534276579186,
  //   original_purchase_date: 1,
  //   is_trial_period: false,
  //   auto_renew_status: false,
  //   source: 'sworkit',
  //   subscription_status: 'expired',
  //   purchase_date: 12,
  //   display_source: 'Sworkit',
  //   subscription_translation_id: 'SWORKIT_YOUTH_INITIATIVE',
  //   email: 'cory@sworkit.com',
  //   email_verified: false,
  //   email_verification_required: boolean;
  // };

  // dev testing => set via sworkit admin
  // const subscriptionResponse = {
  //   error: 'no receipt data available for this user',
  //   is_active_subscriber: true,
  //   source: 'firebase',
  //   subscription_status: 'active'
  // };

  // dev testing => google play
  // const subscriptionResponse = {
  //   uid: '70751dd0-0fa5-4a0d-a665-31b5f2534e42',
  //   product_id: 'ahorsecalledscarlet.sworkit.annualpremium_7999_trials',
  //   price: 79.99,
  //   is_active_subscriber: false,
  //   expires_date: 1559310234121,
  //   original_purchase_date: 1525175068476,
  //   is_trial_period: false,
  //   auto_renew_status: false,
  //   source: 'google',
  //   subscription_status: 'active'
  // };

  // dev testing => stripe
  // const subscriptionResponse: SubscriptionResponse = {
  //   uid: 'facebook:10154323568462281',
  //   product_id: 'SW14DAYSFREE',
  //   purchase_date: 12345,
  //   display_source: 'Stripe',
  //   subscription_translation_id: 'SWORKIT_PREMIUM',
  //   email: 'corytesterson@mailinator.com',
  //   email_verified: true,
  //   is_paying_customer: true,
  //   is_active_subscriber: true,
  //   expires_date: 1534276579186,
  //   original_purchase_date: 1,
  //   is_trial_period: false,
  //   auto_renew_status: false,
  //   source: 'stripe',
  //   subscription_status: 'expired',
  // };

  // dev testing => drs of bc
  // const subscriptionResponse: SubscriptionResponse = {
  //   uid: 'facebook:10154323568462281',
  //   product_id: 'SW14DAYSFREE',
  //   purchase_date: 12345,
  //   display_source: 'Sworkit',
  //   subscription_translation_id: 'SWORKIT_PREMIUM',
  //   email: 'corytesterson@mailinator.com',
  //   email_verified: true,
  //   is_paying_customer: true,
  //   is_active_subscriber: true,
  //   expires_date: 1534276579186,
  //   original_purchase_date: 1,
  //   is_trial_period: false,
  //   auto_renew_status: false,
  //   source: 'doctors-of-bc',
  //   subscription_status: 'expired',
  // };
  if (!subscriptionResponse) return;
  if (autoSignOutConditionMet(subscriptionResponse)) {
    dispatch(signOut());
  }
  amplitudeSetUserProperties({
    subscription_source: subscriptionResponse.source,
    subscription_status: subscriptionResponse.subscription_status,
    is_active_subscriber: subscriptionResponse.is_active_subscriber,
  });
  dispatch(setSubscription(subscriptionResponse));
};

export interface SetSubscription {
  type: TypeKeys.SET_SUBSCRIPTION;
  subscription: SubscriptionResponse;
}

function setSubscription(subscription: SubscriptionResponse) {
  const action: SetSubscription = {
    type: TypeKeys.SET_SUBSCRIPTION,
    subscription,
  };
  return action;
}

export interface SetSubscriptionCancelled {
  type: TypeKeys.SET_SUBSCRIPTION_CANCELLED;
}

export const setSubscriptionCancelled = () => async (dispatch, _getState) => {
  const action: SetSubscriptionCancelled = {
    type: TypeKeys.SET_SUBSCRIPTION_CANCELLED,
  };
  return dispatch(action);
};
